import { Message } from 'ui'

export function BillRatePayNotice() {
  return (
    <Message variant="info">
      Pay rates for this position and location are automatically set by the
      corporate office and cannot be modified. If you have any questions, please
      contact WorkWhile Support or your Account Manager.
    </Message>
  )
}
